module.exports = __webpack_public_path__ + "static/introduction-3cf95573cbd7e65f722b1f11f3ae29a3.png";